import * as Context from 'constants/context';

import { ANNOTATION_TARGETS } from 'constants';
import { LAYOUT_TYPES, LAYOUT_ORIENTATION } from 'constants/layout';

export const BASE_WIDTH = 1200

export const BASE_PHYSICAL_UNIT = 75; // BASE_WIDTH / 16

export const DEFAULT_ASPECT_RATIO = 0.5625;

export const VIEWER_OPTIONS = {
    startTime: 0,
    onTime: () => {},
    environment: HAPYAK_ENVIRONMENT || 'production',
    controls: true,
    autoplay: false,
    scaleToContainer: false
};

export const DEFAULT_REGION_PERCENT = {
    VERTICAL: 33.33,
    HORIZONTAL: 25
};

export const SURROUND_LAYOUT = [
    {
        name: 'root',
        layout: LAYOUT_TYPES.STACK,
        direction: LAYOUT_ORIENTATION.VERTICAL
    },
    {
        name: ANNOTATION_TARGETS.ADJACENT_TOP,
        parent: 'root',
        layout: LAYOUT_TYPES.FILL,
        height: DEFAULT_REGION_PERCENT.VERTICAL
    },
    {
        name: 'middle',
        parent: 'root',
        layout: LAYOUT_TYPES.STACK,
        direction: LAYOUT_ORIENTATION.HORIZONTAL
    },
    {
        name: ANNOTATION_TARGETS.ADJACENT_LEFT,
        parent: 'middle',
        layout: LAYOUT_TYPES.FILL,
        width: DEFAULT_REGION_PERCENT.HORIZONTAL
    },
    {
        name: ANNOTATION_TARGETS.PLAYER,
        parent: 'middle',
        layout: LAYOUT_TYPES.ABSOLUTE,
        aspect: DEFAULT_ASPECT_RATIO * 100,
        physicalWidth: BASE_WIDTH
    },
    {
        name: ANNOTATION_TARGETS.ADJACENT_RIGHT,
        parent: 'middle',
        layout: LAYOUT_TYPES.FILL,
        width: DEFAULT_REGION_PERCENT.HORIZONTAL
    },
    {
        name: ANNOTATION_TARGETS.ADJACENT_BOTTOM,
        parent: 'root',
        layout: LAYOUT_TYPES.FILL,
        height: DEFAULT_REGION_PERCENT.VERTICAL
    }
];

export const DEFAULT_DISPLAY_CONFIG = {
    width: undefined,
    height: undefined,
    aspect: undefined,
    animate: true,
    video: {},
    layout: SURROUND_LAYOUT
};

export const DEFAULT_ANALYTICS_CONFIG = {
    disableAnalytics: false,
    modules: []
};

export const OVERRIDE_CONFIG = {
    project: {},
    annotations: [],
    display: {
        ...DEFAULT_DISPLAY_CONFIG
    },
    analytics: {
        ...DEFAULT_ANALYTICS_CONFIG
    },
    video: {},
    group: {}
};

export const SCALEABLE_ANNOTATIONS = [
    'contents',
    'pop',
    'image',
    'hotlink',
    'iframe'
];

export const PROGRESS_REPORTING_INTERVAL = 10;

export const LIVE_PROGRESS_REPORTING_INTERVAL = 30;

export const ANNOTATION_SCHEMA = {
    TOP_LEVEL_PROPERTIES: [
        'id',
        'type',
        'content',
        'contentType',
        'start',
        'end',
        'top',
        'left',
        'width',
        'height',
        'target',
        'setVariables',
        'precondition'
    ]
};

// Maps disparate legacy properties to 'content' property 
export const LEGACY_PROPERTY_MAP = {
    text: 'content',
    title: 'content',
    src: 'content',
    url: 'content'
};

export const FREQUENT_EVENT_THROTTLE_MS = 32;

export const AVAILABLE_CONTEXT = Object.values(Context);

export const ANIMATION_SETTINGS = {
    props: [],
    frames: {},
    interpolate: false,
    resolution: 4
};

export const TIME_UPDATE_INTERVAL_MS = 250;

export const TIME_UPDATE_INTERVAL_FPS = 4;

export const DEFAULT_WHITELIST = [/^http(s)?\:\/\/[A-z0-9-]+\.hapyak\.com/];

export const REWIND_AMOUNT_SECONDS = 15;
export const TIMELINE_SKIP_PERCENT = 0.01; // used a 1% of duration
export const DEFAULT_LEVEL = "MAX"